const cookiesAccepted = !!localStorage.getItem('cookiesAccepted');
const cookiesContainer = document.querySelector('#cookies');
const cookiesContent = document.querySelector('#cookies .journal-content-article');
const cookiesAcceptBtn = document.querySelector('#accept-cookies');
const cookiesCloseBtn = document.querySelector('#close-cookies');

function showCookies() {
	cookiesContainer.classList.remove('d-none');
}

function closeCookies() {
	cookiesContainer.classList.add('d-none');
}

function acceptCookies() {
	localStorage.setItem('cookiesAccepted', 'true');
	closeCookies();
}

if (!cookiesAccepted && cookiesContainer && cookiesContent) {
	cookiesCloseBtn.addEventListener('click', closeCookies);
	cookiesAcceptBtn.addEventListener('click', acceptCookies);

	showCookies();
}
